import React from "react";
import { useSearchParams } from "react-router-dom";
import { useTracking } from "../../hooks/useTracking";

import TitleSection from "../TitleSection/TitleSection";
import SubtitleSection from "../SubtitleSection/SubtitleSection";
import imgInfo from "../../assets/Page_1/1.5_Info/info_imagen.png";
import Button from "../Button/Button";

import "./SectionInfo.css";

const SectionInfo = () => {
  const [searchParams] = useSearchParams();
  const { trackEvent } = useTracking();

  // Mantenemos la persistencia del contexto si vienen de un test, con fallbacks seguros
  const hospitalClient = searchParams.get("hospital") || "Vertex_Lab_Direct";
  const testName = searchParams.get("test") || "General";

  const handleContactClick = () => {
    trackEvent("click_contact", {
      test_name: testName,
      hospital_client: hospitalClient,
      contact_method: "email",
      contact_target: "comunicacion@apec.com.mx"
    });
  };

  return (
    <section className="section-info">
      <TitleSection titleSection={"Info"} />
      <SubtitleSection subtitleSection={"¿Necesitas más información?"} />
      <img src={imgInfo} alt="img-section-info" className="img-section-info" />
      <p className="section-info-paragraph">
        Estamos aquí para ayudarte. Si necesitas información sobre los tests,
        resultados o recomendaciones personalizadas, ponte en contacto con
        nosotros.
      </p>
      <a
        href="mailto:comunicacion@apec.com.mx"
        className="link"
        onClick={handleContactClick}
      >
        <Button text={"Escríbenos"} className="" />
      </a>
    </section>
  );
};

export default SectionInfo;
